__webpack_require__.p = "/ws101-Ligon-navbar/";